import styled from "@rentiohq/web-theme";

export const TabsWrap = styled.div`
  border-bottom: 1px solid ${props => props.theme.getColor("gray", 200)};
`;

/** The SMS as the example candidate reads it, set apart from the box above it. */
export const SmsPreview = styled.div`
  white-space: pre-wrap;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${props => props.theme.getColor("gray", 0)};
`;

/** Below this width the variables box sits under the texts instead of beside them. */
const SIDE_BY_SIDE_MIN_WIDTH = "1000px";

/** How far below the top of the window the variables box stays while scrolling. */
const VARIABLES_STICKY_TOP = "24px";

/** The texts on the left, the variables box on the right (DEV-3553). */
export const TabLayout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;

  @media (max-width: ${SIDE_BY_SIDE_MIN_WIDTH}) {
    flex-direction: column;
  }
`;

export const TabContent = styled.div`
  flex: 1 1 600px;
  min-width: 0;
`;

/**
 * The variables of the text being written, kept in view while the office
 * scrolls down to the next language; under the texts, and no longer sticky,
 * when there is no room beside them.
 */
export const VariablesBox = styled.aside`
  flex: 0 0 340px;
  position: sticky;
  top: ${VARIABLES_STICKY_TOP};
  margin-top: 24px;
  margin-left: auto;
  padding: 16px 20px;
  border-radius: 8px;
  background: ${props => props.theme.getColor("gray", 0)};

  @media (max-width: ${SIDE_BY_SIDE_MIN_WIDTH}) {
    position: static;
    flex-basis: auto;
    width: 100%;
    max-width: 600px;
    margin-left: 0;
    box-sizing: border-box;
  }
`;

export const VariableList = styled.div`
  margin-top: 8px;
`;

/** One variable per row, a thin line between them, so the box reads as a list. */
export const VariableRow = styled.div`
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  column-gap: 8px;
  align-items: baseline;
  padding: 6px 0;
  border-top: 1px solid ${props => props.theme.getColor("gray", 200)};

  &:last-child {
    border-bottom: 1px solid ${props => props.theme.getColor("gray", 200)};
  }
`;
